import React from 'react';

/**
 * The personal brand mark: an astrolabe reduced to two rings, an alidade and a
 * solid pivot. Inlined rather than loaded as an image so it inherits
 * `currentColor` and stays crisp at any size.
 *
 * Geometry is kept in step with scripts/generate-brand-icons.mjs, which builds
 * the favicon and application icons from the same drawing.
 */
function BrandMark({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="32" cy="32" r="26" />
      <circle cx="32" cy="32" r="16.5" />
      <path d="M32 32L50.38 13.62" />
      <circle cx="32" cy="32" r="3" fill="currentColor" stroke="none" />
    </svg>
  );
}

export default BrandMark;
